<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <h3>Faturar os serviços realizados</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
<!--        <v-alert v-if="system.alertError" v-model="system.alertError" dismissible type="error">-->
<!--          <ul>-->
<!--            <li v-for="error in system.alertInfo" :key="error.index">{{error[0]}}</li>-->
<!--          </ul>-->
<!--        </v-alert>-->
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-row>
          <v-col>
            <v-autocomplete
              v-model="IdUnidade"
              :items="unidadesList"
              :rules="[v => !!v || 'Campo obrigatório!']"
              item-text="Unidade"
              item-value="IdUnidade"
              label="Unidade"
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="tipoFiltro"
              :items="tipoAtendimentos"
              :rules="[v => !!v || 'Campo obrigatório!']"
              item-text="tipo"
              item-value="valor"
              label="Tipo de atendimento"
              required
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-menu
              v-model="menuDataInicialFiltro"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dataInicialFiltro"
                  label="Data Inicial"
                  readonly
                  :rules="tipoFiltro == 1 ? [v => !!v || 'Campo obrigatório!'] : [true]"
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataInicialFiltro"
                @input="menuDataInicialFiltro = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-menu
              v-model="menuDataFinalFiltro"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dataFinalFiltro"
                  label="Data Final"
                  readonly
                  :rules="tipoFiltro == 1 ? [v => !!v || 'Campo obrigatório!'] : [true]"
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                :min="dataInicialFiltro"
                v-model="dataFinalFiltro"
                @input="menuDataFinalFiltro = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <!-- <v-col cols="2">
            <v-autocomplete
                v-model="tipoProgramaExame"
                :items="tiposProgramasExames"
                item-text="tipo"
                item-value="valor"
                label="Tipo de Serviço"
            ></v-autocomplete>
          </v-col> -->
          <v-col>
            <v-btn
              @click="getAgendamentos"
              color="primary"
              class="mt-3"
              dark
              block
              >Buscar</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
        <!-- <v-row>
          <v-col cols="10" sm="9" md="8" lg="10" xl="10">
            <v-file-input
              v-model="arquivoRetorno"
              accept=".ret"
              label="arquivo de retorno do banco"
            ></v-file-input>
          </v-col>
          <v-col cols="2" sm="3" md="4" lg="2" xl="2">
            <v-btn
              :loading="loadRetorno"
              @click="processarRetorno()"
              class="mt-3"
              dark
              block
              color="primary"
              >processar</v-btn
            >
          </v-col>
        </v-row> -->
        <v-row>
          <v-col cols="9" sm="6" md="6" lg="9" xl="10">
            <v-text-field
              v-model="search"
              prepend-icon="mdi-feature-search-outline"
              label="Pesquisar"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="3" sm="6" md="6" lg="3" xl="2">
            <v-btn
              @click="[dialogConfirmarGeral = true]"
              class="mt-3"
              dark
              block
              color="primary"
              >Relatório de Provisões</v-btn
            >
          </v-col>
        </v-row>
        <v-data-table
          :items="empresas"
          :headers="headers"
          :search="search"
          :loading="loadFatura"
        >
          <template v-slot:[`item.statusProcesso`]="{ item }">
            <StatusProcesso :status="item"></StatusProcesso>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="[getServicosDeAgendamento(item.NumeroContrato, item.IdEmpresa)]">
                  <v-icon>mdi-format-list-bulleted-square</v-icon>
                </v-btn>
              </template>
              <span>listagem dos agendamentos</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  color=green
                  @click="
                    [
                      (IdRelatorio = 2),
                      getAgendamento(item),
                      getIdEmpresa(item.IdEmpresa, item.IdContrato, item.ParcelasFatura, item.IdFormaPagamento, item.FormaPagamento),
                      gerarFatura(item.Cor, item.IdContrato, item.IdAgendamento),
                    ]
                  "
                  icon
                >
                  <v-icon>mdi-file-document</v-icon>
                </v-btn>
              </template>
              <span>Gerar extrato dos atendimentos em aberto</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  color=orange
                  @click="
                    [
                      (IdRelatorio = 1),
                      getAgendamento(item),
                      getIdEmpresa(item.IdEmpresa, item.IdContrato, item.ParcelasFatura, item.IdFormaPagamento, item.FormaPagamento),
                      gerarFatura(item.Cor),
                    ]
                  "
                  icon
                >
                  <v-icon>mdi-chart-timeline</v-icon>
                </v-btn>
              </template>
              <span>Gerar relatório de provisão de receitas</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  color=primary
                  @click="[(modalPeriodoFaturar = true),
                  getRangeVencimento(),
                  getIdEmpresa(item.IdEmpresa, item.IdContrato, item.ParcelasFatura, item.IdFormaPagamento, item.FormaPagamento),
                  getAgendamento(item)]"
                  icon
                >
                  <v-icon>mdi-currency-usd</v-icon>
                </v-btn>
              </template>
              <span>Registrar a emissão da fatura</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Dialog para confirmar relatório de provisões geral -->

    <v-dialog v-model="dialogConfirmarGeral" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Relatório geral de provisões
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              O relatório geral de provisões fornecerá informações de todas as empresas no período escolhido, em decorrência disso pode levar de vários segundos a até mesmo um minuto.
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="dialogConfirmarGeral = false"
          >
            Voltar
          </v-btn>
          <v-btn
              :loading="loadFatura"
              @click="[dialogConfirmarGeral = false, (IdRelatorio = 1), gerarFatura(null)]"
              text
              color="primary"
          >Gerar Relatório</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Gerar Fatura -->

    <v-dialog width="70%" v-model="modalPeriodoFaturamento">
      <v-card>
        <v-card-title>Gerar relatório</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert
            v-if="system.alertError"
            v-model="system.alertError"
            dismissible
            type="error"
          >
            <ul>
              <li v-for="error in system.alertInfo" :key="error.index">
                {{ error[0] }}
              </li>
            </ul>
          </v-alert>
          <v-row>
            <v-col cols="6">
              <v-menu
                v-model="menuDataInicial"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dataInicialFiltro"
                    label="Data Inicial"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    type="date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dataInicialFiltro"
                  @input="menuDataInicial = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="menuDataFinal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dataFinalFiltro"
                    label="Data Final"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    type="date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="dataInicialFiltro"
                  v-model="dataFinalFiltro"
                  @input="menuDataFinal = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                v-model="IdUnidade"
                :items="unidadesList"
                item-text="Unidade"
                item-value="IdUnidade"
                label="Unidade"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                v-model="IdRelatorio"
                :items="relatoriosList"
                item-text="Relatorio"
                item-value="IdRelatorio"
                label="Tipo de relatório"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="numeroCNPJ"
                label="CNPJ (Opcional)"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loadFatura"
            @click="
              [(loader = 'loading'), gerarFatura(), (system.alertError = false)]
            "
            dark
            large
          >
            Gerar Relatório
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Faturar -->
    <v-dialog width="70%" v-model="modalPeriodoFaturar">
      <v-card>
        <v-card-title>
          Registrar faturamento
          <v-spacer></v-spacer>
          <v-btn @click="[faturado=false, modalPeriodoFaturar = !modalPeriodoFaturar]" icon>
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert
            v-if="system.alertError"
            v-model="system.alertError"
            dismissible
            type="error"
          >
            <ul>
              <li v-for="error in system.alertInfo" :key="error.index">
                {{ error[0] }}
              </li>
            </ul>
          </v-alert>
          <v-row>
            <v-col cols="3">
              <v-autocomplete
                  v-model="IdUnidade"
                  :items="unidadesList"
                  item-text="Unidade"
                  item-value="IdUnidade"
                  label="Unidade"
                  disabled
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-menu
                v-model="faturar.menuDataInicial"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dataInicialFiltro"
                    label="Data Inicial"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    type="date"
                    disabled
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dataInicialFiltro"
                  @input="faturar.menuDataInicial = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="3">
              <v-menu
                v-model="faturar.menuDataFinal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dataFinalFiltro"
                    label="Data Final"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    type="date"
                    disabled
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="dataInicialFiltro"
                  v-model="dataFinalFiltro"
                  @input="faturar.menuDataFinal = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="3">
              <v-menu
                  v-model="menuDataVencimento"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="DataVencimento"
                      label="Vencimento"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      type="date"
                  ></v-text-field>
                </template>
                <v-date-picker
                    :min="rangeMin"
                    :max="rangeMax"
                    v-model="DataVencimento"
                    @input="menuDataVencimento = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                  :items="tiposPagamento"
                  v-model="faturar.FormaPagamento"
                  item-text="FormaPagamento"
                  item-value="IdFormaPagamento"
                  label="Forma de pagamento">
              </v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-text-field
                  v-model="ParcelasFatura"
                  label="Parcelas"
                  persistent-hint outline
                  type="number"
                  :rules="[rules.maxParcelas]"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                type="number"
                min="1"
                v-model="faturar.numeroNotaFiscal"
                label="Número da Nota Fiscal"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-file-input
                  ref="notafiscal"
                  accept=".pdf"
                  v-model="faturar.notaFiscal"
                  label="Nota Fiscal"
              ></v-file-input>
            </v-col>
            <v-col cols="12">
              <vue-editor label="Instruções Boleto" v-model="faturar.instrucoesBoleto"></vue-editor>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
<!--          <v-layout class="justify-end pr-2">-->

<!--              <v-card class="green">-->
<!--                <v-card-text class="white&#45;&#45;text">-->
<!--                  Faturamento realizado!-->
<!--&lt;!&ndash;                  Confira seu email e/ou a aba de Serviços Faturados para mais detalhes.&ndash;&gt;-->
<!--                </v-card-text>-->
<!--              </v-card>-->

<!--          </v-layout>-->
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loadGerarFatura"
            @click="[postFaturar()]"
            dark
            large
            >Registrar faturamento</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="80%" scrollable v-model="listarServicos" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card flat>
        <v-card-title>
          Relação dos agendamentos vinculados ao contrato
          <v-spacer></v-spacer>
          <v-btn icon @click="listarServicos = false">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card-text class="pa-8" v-if="servicos_do_agendamento.length != 0" >
            <v-row>
              <template>
                <h3><strong>CNPJ: {{servicos_do_agendamento[0].CNPJ}}</strong></h3>
              </template>
            </v-row>
            <v-row>
              <template>
                <h4><strong>Razão Social: {{servicos_do_agendamento[0].RazaoSocial}}</strong></h4>
              </template>
            </v-row>
            <v-row>
              <template>
                <h4><strong>Contrato: {{servicos_do_agendamento[0].NumeroContrato}}</strong></h4>
              </template>
            </v-row>
          </v-card-text>
          <v-card-title>
            <v-col cols="12">
              <v-text-field
                  v-model="searchServicos"
                  prepend-icon="mdi-magnify"
                  label="Pesquisar"
              ></v-text-field>
            </v-col>
          </v-card-title>
          <v-data-table
              :headers="headersServicos"
              :items="servicos_do_agendamento"
              :search="searchServicos"
              class="elevation-1"
              loading-text="Carregando..."
          >
            <template v-slot:[`item.cobrarTaxaDeslocamento`]="{ item }">
            <v-chip v-if="item.cobrarTaxaDeslocamento" class="blue" dark>Sim</v-chip>
            <v-chip v-else class="gray" dark>Não</v-chip>
          </template>
            <template v-slot:[`item.dataInicial`]="{ item }">
              {{$moment(item.dataInicial).format('L')}}
            </template>
            <template v-slot:[`item.statusProcesso`]="{ item }">
              <StatusProcesso :status="item"></StatusProcesso>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on"
                    :disabled="item.contarEstatistica == 0 || item.IdStatusProcesso >= 2 || !item.anexos.length"
                    icon @click="get_anexo(item.IdAgendamento, item.IdAgendamentoServico)">
                  <v-icon>mdi-file-eye</v-icon>
                  </v-btn>
                </template>
                <span>visualizar anexos</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon @click="[getServicos(item.IdAgendamento), getIdEmpresa(item.IdEmpresa)]">
                    <v-icon>mdi-account-multiple</v-icon>
                  </v-btn>
                </template>
                <span>participantes</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <AlertSystem :snackbar="system.snackbar"></AlertSystem>
  </v-container>
</template>

<script>
// @ is an alias to /src
import moment from "moment";
import AlertSystem from "../components/AlertSystem.vue";
import StatusProcesso from "../components/StatusProcesso.vue";
import { VueEditor } from "vue2-editor"

export default {
  name: "Faturar",
  components: {
    AlertSystem,
    StatusProcesso,
    VueEditor
  },
  data: () => ({
    isInputActive: false,
    valid: true,
    system: {
      snackbar: {},
      alertInfo: [],
      alertError: false,
    },
    rules: {
      maxParcelas: value => value <= 10 || 'Limite máximo de 10 parcelas',
    },
    headers: [
      { text: "CNPJ", value: "CNPJ", width: "20%"},
      { text: "Razão Social", value: "RazaoSocial", width: "40%"},
      { text: "Contrato", value: "NumeroContrato", width: "10%"},
      // { text: "Status", value: "statusProcesso", align: "center", width: "10%"},
      { text: "Ações", value: "actions", align: "right", width: "20%"},
    ],
    menuDataInicialFiltro: false,
    menuDataFinalFiltro: false,
    dataInicialFiltro: null,
    dataFinalFiltro: null,
    tipoFiltro: null,
    empresas: [],
    tipoProgramaExame: null,
    relatoriosList: [
      {
        IdRelatorio: 1,
        Relatorio: "Relatório de provisão de receitas",
      },
      {
        IdRelatorio: 2,
        Relatorio: "Extrato de atendimentos realizados",
      },
    ],
    loadGerarFatura: false,
    arquivoRetorno: [],
    loadRetorno: false,
    numeroCNPJ: null,
    IdRelatorio: null,
    search: "",
    status: 1,
    loadFatura: false,
    modalPeriodoFaturamento: false,
    modalPeriodoFaturar: false,
    dialogConfirmarGeral: false,
    agendamento: {},
    dataInicialFatura: "",
    dataFinalFatura: "",
    menuDataInicial: false,
    menuDataFinal: false,
    dynamicColTipo: 4,
    dynamicColBtn: 2,
    faturar: {
      numeroNotaFiscal: "",
      menuDataInicial: false,
      menuDataFinal: false,
      dataInicialFatura: "",
      dataFinalFatura: "",
      instrucoesBoleto: "<p>Juros..........: 1% ao mês</p><p>Multa..........: 2% após 1 dia corrido do vencimento</p><p>Negativar....: 30 dias corridos após o vencimento</p><p>REF NFE</p>",
      IdUnidade: null,
      IdEmpresa: null,
      dataVencimento: "",
      FormaPagamento: null,
      notaFiscal: null,
    },
    tipoAtendimentos: [
      { tipo: "Internos", valor: 1 },
      { tipo: "Externos", valor: 2 },
    ],
    tiposProgramasExames: [
      { tipo: "Todos", valor: null },
      { tipo: "Programa", valor: 1 },
      { tipo: "Exame", valor: 0 },
    ],
    unidadesList: [],
    IdUnidade: "",
    IdEmpresa: "",
    NumeroContrato: "",
    ParcelasFatura: 1,
    FormaPagamento: null,
    NomeFormaPagamento: null,
    DataVencimento: "",
    menuDataVencimento: false,
    rangeMin: "",
    rangeMax: "",
    faturado: false,
    tiposPagamento: [],
    agendamentos_com_anexo: [],
    servicos_do_agendamento: [],
    listarServicos: false,
    searchServicos: null,
    headersServicos: [
      { text: "Id", value: "IdAgendamento" },
      { text: "Data", value: "dataInicial" },
      { text: "Titulo", value: "Procedimento" },
      { text: 'Taxa de deslocamento', value: 'cobrarTaxaDeslocamento' },
      { text: "Ações", value: "actions", align: 'right' }
    ],
    ocorrencias: null,
    qtdAnexos: null
  }),
  methods: {
    forceFileDownload(response, title) {
      const [url, link] = [window.URL.createObjectURL(new Blob([response.data])), document.createElement('a')]
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    get_anexo(IdAgendamento, IdAgendamentoServico){
      this.axios.get(`execucoes/evidencias/${IdAgendamentoServico}`,{
      }).then((res) => {
        var data = moment(res.data[0].created_at).format('YYYY-MM-DD HH:mm:ss')
        this.visualizar_anexo(IdAgendamento, IdAgendamentoServico, data)
      })
    },
    // dar um get em /api/v1/execucoes/evidencias/6653 para pegar o created at
    // usar o created_at para pegar o arquivo
    // criar o modal para pegar o arquivo
    visualizar_anexo(IdAgendamento, IdAgendamentoServico, DataOcorrencia) {
      this.axios.get(`agendamentos/${IdAgendamentoServico}/evidencias/${DataOcorrencia}`,{
        responseType: 'arraybuffer'
      }).then((res) => {
        this.forceFileDownload(res, DataOcorrencia + '.pdf')
      })
    },
    async getServicosAnexos(IdAgendamento) {
      const { data } = await this.axios.get(`agendamentos/${IdAgendamento}/servicos`)
      this.servicos_do_agendamento = data
    },
    validate(){
      this.$refs.form.validate()
    },
    getRangeVencimento(){
      this.rangeMin =  moment().format('YYYY-MM-DD');
      this.rangeMax =  moment().add(30, 'days').format('YYYY-MM-DD');
    },
    getUnidades() {
      this.axios("unidades").then((res) => {
        this.unidadesList = res.data;
      });
    },
    getAgendamento(agendamento) {
      this.agendamento = agendamento;
    },
    getIdEmpresa(IdEmpresa, NumeroContrato, ParcelasFatura, IdFormaPagamento, FormaPagamento) {
      this.IdEmpresa = IdEmpresa;
      this.NumeroContrato = NumeroContrato;
      this.FormaPagamento = IdFormaPagamento;
      this.NomeFormaPagamento = FormaPagamento;
    },
    gerarFatura(Cor, IdContrato, IdAgendamento) {
      this.loadFatura = true;
      if(Cor==null){
        this.axios.get("relatoriogeral", {
          params: {
            lngTipoRelatorio: this.IdRelatorio,
            strDataInicio: this.dataInicialFiltro,
            strDataFim: this.dataFinalFiltro,
            lngUnidade: this.IdUnidade,
            lngCNPJ: this.numeroCNPJ,
            lngEmpresa: this.IdEmpresa,
            lngTipoAtendimento: this.tipoFiltro,
            lngTipoProgramaExame: this.tipoProgramaExame,
            lngContrato: null,
            lngAgendamento: null,
            lngCor: Cor
          },
          responseType: 'arraybuffer'
        })
        .then((res) => {
          var blob = new Blob([res.data], {
            type: "application/pdf",
          });
          var url = window.URL.createObjectURL(blob);
          window.open(url);
          //this.loadFatura = false
          //this.modalPeriodoFaturamento = false
        })
        .catch(error => {
          // clearInterval
          if (error.response.status == 400) {
            this.system.snackbar = {
              snackbar: true,
              text: 'Informe a unidade e as datas corretamente',
              color: "red",
            };
          }
        })
        .finally(() => {
          this.loadFatura = false;
          this.IdRelatorio = null;
          this.dynamicColTipo = 4;
          this.IdEmpresa = null;
          this.NumeroContrato = null;
        });
      }else{
        if (this.IdRelatorio == 1) {
          this.axios
              .get("relatorio", {
                params: {
                  lngTipoRelatorio: this.IdRelatorio,
                  strDataInicio: this.dataInicialFiltro,
                  strDataFim: this.dataFinalFiltro,
                  lngUnidade: this.IdUnidade,
                  lngCNPJ: this.numeroCNPJ,
                  lngEmpresa: this.IdEmpresa,
                  lngTipoAtendimento: this.tipoFiltro,
                  lngTipoProgramaExame: this.tipoProgramaExame,
                  lngContrato: this.NumeroContrato,
                  lngAgendamento: this.agendamento.IdAgendamento,
                  lngCor: Cor
                },
                responseType: 'arraybuffer'
              })
              .then((res) => {
                var blob = new Blob([res.data], {
                  type: "application/pdf",
                });
                var url = window.URL.createObjectURL(blob);
                window.open(url);
                //this.loadFatura = false
                //this.modalPeriodoFaturamento = false
              })
              .catch(error => {
                // clearInterval
                if (error.response.status == 400) {
                  this.system.snackbar = {
                    snackbar: true,
                    text: 'Informe a unidade e as datas corretamente',
                    color: "red",
                  };
                }
              })
              .finally(() => {
                this.loadFatura = false;
                this.IdRelatorio = null;
                this.dynamicColTipo = 4;
                this.IdEmpresa = null;
                this.NumeroContrato = null;
              });
        } else {
          this.axios(
              `execucoes/${this.agendamento.IdAgendamento}/faturas?dataInicialFatura=${this.dataInicialFiltro}&dataFinalFatura=${this.dataFinalFiltro}&IdEmpresa=${this.IdEmpresa}&IdUnidade=${this.IdUnidade}`,
              {
                params: {
                  lngUnidade: this.IdUnidade,
                  lngTipoRelatorio: this.IdRelatorio,
                  lngTipoAtendimento: this.tipoFiltro,
                  lngTipoProgramaExame: this.tipoProgramaExame,
                  lngContrato: this.NumeroContrato,
                  lngCor: Cor,
                  IdContrato: IdContrato,
                  IdAgendamento: IdAgendamento
                  // aqui
                },
                responseType: 'arraybuffer'
              }
          )
          .then((res) => {
            var blob = new Blob([res.data], {
              type: "application/pdf",
            });
            var url = window.URL.createObjectURL(blob);
            window.open(url);
          })
          .catch(error => {
            // clearInterval
            if (error.response.status == 400) {
              this.system.snackbar = {
                snackbar: true,
                text: 'Informe a unidade e as datas corretamente',
                color: "red",
              };
            }
          })
          .finally(() => {
            this.loadFatura = false;
            this.IdRelatorio = null;
            this.dynamicColTipo = 4;
            this.IdEmpresa = null;
            this.NumeroContrato = null;
          });
        }
      }
    },
    async postFaturar() {
      this.loadGerarFatura = true;
      this.faturar.IdUnidade = this.IdUnidade
      this.faturar.IdEmpresa = this.agendamento.IdEmpresa
      this.faturar.dataInicialFatura = this.dataInicialFiltro
      this.faturar.dataFinalFatura = this.dataFinalFiltro
      this.faturar.lngContrato = this.NumeroContrato
      this.faturar.dataVencimento = this.DataVencimento

      let formData = new FormData();
      formData.append(`files`, this.faturar.notaFiscal);
      // dados de faturamento
      for (let key in this.faturar) {
        if(this.faturar[key] != null) {
          formData.append(`fatura[${key}]`, this.faturar[key]);
        } else {
          formData.append(`fatura[${key}]`, '');
        }
      }
      formData.append(`parcelas`, this.ParcelasFatura);
      if(this.agendamento.IdAgendamento != null) {
        formData.append(`IdAgendamento`, this.agendamento.IdAgendamento);
      }
      formData.append(`FormaPagamento`, this.faturar.FormaPagamento,);

      this.axios
        .post('/faturamentos', formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          // for(var i=0;i < res.data.nossoNumero.length;i++){
          //   var url = `http://boleto.dti.systems/api/boleto/gerar/${res.data.nossoNumero[i]}`;
          //   window.open(url);
          // }
          this.system.snackbar = {
            snackbar: true,
            text: res.data.message,
            color: "green",
          };
          this.faturado = true
          this.faturar.numeroNotaFiscal = null
          this.faturar.FormaPagamento = null
          this.ParcelasFatura = null
          this.faturar.notaFiscal = []
          this.faturar.instrucoesBoleto = null
          this.modalPeriodoFaturar = false
        })
        .catch((e) => {
          this.system.snackbar = {
            snackbar: true,
            text: e.response.data,
            color: "red"
          };
          this.system.alertInfo = e.response.data;
          this.system.alertError = true;
        })
        .finally(() => {
          this.getAgendamentos();
          this.loadGerarFatura = false;
        });
    },
    gerarBoleto() {},
    gerarNotaFiscal() {},

    anexarNotaFiscal(id) {
      let formData = new FormData();
      formData.append(`files`, this.faturar.notaFiscal);
      this.axios.post(`faturamentos/${id}/notafiscal`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => {
        // this.system.snackbar = {
        //   snackbar: true,
        //   text: res.data,
        //   color: "green",
        // };
        this.faturar.notaFiscal = [];
      })
      .catch((e) => {
        this.system.snackbar = {
          snackbar: true,
          text: e.response.data,
          color: "red",
        };
      }).finally(() => {
        this.getAgendamentos();
      })
    },
    processarRetorno() {
      this.loadRetorno = true;
      let formData = new FormData();
      formData.append(`files`, this.arquivoRetorno);
      this.axios
        .post("faturamentos/retornos", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.system.snackbar = {
            snackbar: true,
            text: res.data,
            color: "green",
          };
          this.getAgendamentos();
          this.arquivoRetorno = [];
        })
        .catch((e) => {
          this.system.snackbar = {
            snackbar: true,
            text: e.response.data.files[0],
            color: "red",
          };
        })
        .finally(() => {
          this.loadRetorno = false;
        });
    },
    getFormasPagamento(){
      this.axios.get('/faturamentos/formasPagamento')
          .then( res => {
            this.tiposPagamento = res.data
          })
    },
    getServicosDeAgendamento(NumeroContrato, IdEmpresa){
      this.agendamentos_com_anexo = this.empresas.filter(arr => {
        return NumeroContrato === arr.NumeroContrato && arr.IdEmpresa === IdEmpresa
      })
      this.getServicosAnexos(this.agendamentos_com_anexo[0].IdAgendamento)
      this.listarServicos = !this.listarServicos
    },
    getAgendamentos() {
      if(this.$refs.form.validate()){
        this.loadFatura = true;
        this.axios
          .get("agendamentos/filtros/faturas?", {
            params: {
              status: 0,
              dataInicialFiltro: this.dataInicialFiltro,
              dataFinalFiltro: this.dataFinalFiltro,
              tipoFiltro: this.tipoFiltro,
              IdUnidade: this.IdUnidade,
              Sebraetec: this.$route.params.Sebraetec === 'sebraetec' ? true : null,
              Servico: this.$route.params.Servico === 'servicos' && this.$route.params.Sebraetec === 'realizados' ? true : null
            },
          })
          .then((res) => {
            this.empresas = res.data.filter( empresa => {
              empresa.RazaoSocial = this.prepareNameFilter(empresa.RazaoSocial);
              return empresa;
            });
          })
          .finally(() => {
            this.getFormasPagamento()
            this.loadFatura = false;
          });
      }
    },
  },
  mounted() {
    this.getUnidades();
  },
};
</script>
